class PickPack extends HTMLElement {
  constructor() {
    super();

    this.maxTotal = parseInt(this.getAttribute('data-pick-count'), 10) || 3;
    this.modal = document.getElementById('flavor-modal');
    this.focusTrapEls = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    this.paymentOptions = document.querySelector('.pyp .product-form__buttons')
    this.selectionLabel = document.querySelector('.flavor-selections')
    this.togglePaymentButtons(false)

    const submitBtn = document.querySelector('.product-form__submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', this.handleFormSubmit.bind(this));
    }

    const products = this.querySelectorAll('.pick-flavor');
    if (products.length) {
      products.forEach(product => {
        const productHandle = product.getAttribute('data-flavor-handle');
        const productContent = product.querySelector('.pick-flavor__content');

        if (productContent) {
          productContent.addEventListener('click', () => {
            this.openModal(productHandle);
          });
        }
      });
    }

    this.modal?.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeModal();
      if (e.key === 'Tab') this.trapFocus(e);
    });

    const closeBtn = this.modal.querySelector('[data-close-modal]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.closeModal.bind(this));
    }

    this.initQuantitySelectors();
  }

  togglePaymentButtons(toggle) {
    if (this.paymentOptions) {
      if (toggle) {
        this.paymentOptions.style.opacity = 1
        this.paymentOptions.style.pointerEvents = 'auto'
      } else {
        this.paymentOptions.style.opacity = 0.3
        this.paymentOptions.style.pointerEvents = 'none'
      }
    }
  }

  openModal(productHandle) {
    if (!this.modal) return;

    this.modal.classList.add('is-visible');
    this.modal.removeAttribute('inert');
    this.modal.setAttribute('tabindex', '-1');
    this.modal.focus();

    this.modal.innerHTML = `
      <div class="modal-content" role="dialog" aria-modal="true" aria-label="Product details" style="display: flex; justify-content: center; align-items: center;">
        <button data-close-modal class="modal-close" aria-label="Close modal">&times;</button>
        <p class="h3">Loading...</p>
      </div>
    `;

    fetch(`/products/${productHandle}?view=description-only`)
      .then(res => res.text())
      .then(html => {
        if (!this.modal) return;

        this.modal.innerHTML = `
          <div class="modal-content" role="dialog" aria-modal="true" aria-label="Product details">
            <button data-close-modal class="modal-close" aria-label="Close modal">&times;</button>
            ${html}
          </div>
        `;

        this.modal.querySelector('[data-close-modal]')
          ?.addEventListener('click', this.closeModal.bind(this));
      });
  }

  closeModal() {
    if (this.modal) {
      document.activeElement.blur();
      this.modal.classList.remove('is-visible');
      this.modal.setAttribute('inert', '');
      this.modal.removeAttribute('aria-modal');
      this.modal.removeAttribute('role');
      this.modal.removeAttribute('tabindex');
      this.modal.innerHTML = '';
    }
  }

  trapFocus(e) {
    if (!this.modal || !this.modal.classList.contains('is-visible')) return;

    const focusables = this.modal.querySelectorAll(this.focusTrapEls);
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  initQuantitySelectors() {
    const updateQuantities = () => {
      const allSelectors = this.querySelectorAll('.pick-flavor');
      let totalQty = 0;

      allSelectors.forEach((el) => {
        const input = el.querySelector('.qty');
        totalQty += parseInt(input.value, 10);
      });

      allSelectors.forEach((el) => {
        const input = el.querySelector('.qty');
        const minus = el.querySelector('.minus');
        const plus = el.querySelector('.plus');
        const currentQty = parseInt(input.value, 10);

        minus.disabled = currentQty <= 0;
        plus.disabled = totalQty >= this.maxTotal;
      });
      this.syncHiddenInputs();
    };

    this.querySelectorAll('.pick-flavor').forEach((el) => {
      const input = el.querySelector('.qty');
      const minus = el.querySelector('.minus');
      const plus = el.querySelector('.plus');

      minus.addEventListener('click', () => {
        let value = parseInt(input.value, 10);
        if (value > 0) {
          input.value = value - 1;
          updateQuantities();
        }
      });

      plus.addEventListener('click', () => {
        let currentTotal = Array.from(this.querySelectorAll('.qty')).reduce((sum, input) => {
          return sum + parseInt(input.value, 10);
        }, 0);

        if (currentTotal < this.maxTotal) {
          input.value = parseInt(input.value, 10) + 1;
          updateQuantities();
        }
      });
    });

    updateQuantities();
  }

  syncHiddenInputs() {
    const container = document.querySelector('.flavor-inputs');
    const selectedList = document.querySelector('.flavors-list');

    if (!container) return;

    container.innerHTML = '';
    selectedList.innerHTML = '';

    const totalSelected = Array.from(this.querySelectorAll('.qty')).reduce((sum, input) => {
      return sum + parseInt(input.value, 10);
    }, 0);

    this.selectionLabel.innerHTML = `${totalSelected} / ${this.maxTotal} Selected`;
    if (totalSelected < this.maxTotal) {
      this.selectionLabel.classList.remove('success');
    } else {
      this.selectionLabel.classList.add('success');
    }

    console.log('total selected', totalSelected, this.maxTotal);
    this.togglePaymentButtons(totalSelected >= this.maxTotal);

    const flavors = this.querySelectorAll('.pick-flavor');
    const selectedUl = document.createElement('ul');

    flavors.forEach((el) => {
      const input = el.querySelector('.qty');
      const qty = parseInt(input.value, 10);
      if (qty > 0) {
        const title = el.getAttribute('data-product-title');
        if (title) {
          const selectedLi = document.createElement('li');
          selectedLi.innerHTML = `<p class="h3">${title} x${qty}</p>`;
          selectedUl.appendChild(selectedLi);

          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = `properties[${title}]`;
          hidden.value = `x${qty}`;
          container.appendChild(hidden);
        }
      }
    });

    selectedList.appendChild(selectedUl);
  }

  handleFormSubmit(e) {
    const totalSelected = Array.from(this.querySelectorAll('.qty')).reduce((sum, input) => {
      return sum + parseInt(input.value, 10);
    }, 0);

    const errorEl = document.querySelector('.flavor-error');
    const missing = this.maxTotal - totalSelected;

    if (missing > 0) {
      e.preventDefault();

      if (errorEl) {
        errorEl.textContent = `Choose ${missing} more item${missing === 1 ? '' : 's'}`;
      }
    } else {
      if (errorEl) errorEl.textContent = '';
    }
  }
}

customElements.define('pick-flavors', PickPack);
